import { render, staticRenderFns } from "./big-commerce-pair-complete.vue?vue&type=template&id=72d9eca8&scoped=true&"
import script from "./big-commerce-pair-complete.vue?vue&type=script&lang=js&"
export * from "./big-commerce-pair-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9eca8",
  null
  
)

export default component.exports